import { useEffect, useRef, useState } from 'react';
import { Session, SessionTypesEnum, FeatureFlagMap, FeatureFlagsEnum } from '../types/working-model';

const CHECKINTERVAL = 3000;

export default function useLive(playbackUrl: string | null, session?: Session, featureFlags?: FeatureFlagMap): boolean {
	const [isLive, setIsLive] = useState(false);
	const checkInterval = useRef<NodeJS.Timeout | undefined>();
	const abortController = useRef<AbortController | undefined>();

	useEffect(() => {

		//needed to cancel the request when playbackUrl changes
		abortController.current = new AbortController();
		const { signal } = abortController.current;

		//only if user has set a playback url
		if (playbackUrl && !playbackUrl.startsWith('<iframe')) {
			//check the playbackUrl for a 404
			fetch(playbackUrl, { signal }).then(result => {
				//if the playback url has returned ok, channel is live
				setIsLive(result.ok);
			}).catch(e => {
				console.log(e);
			});

			checkInterval.current = setInterval(() => {
				//check the playbackUrl for a 404
				fetch(playbackUrl, { signal }).then(result => {
					//if the playback url has returned ok, channel is live
					setIsLive(result.ok);
				}).catch(e => {
					console.log(e);
				});
			}, CHECKINTERVAL);
		}
		else if (session && !featureFlags?.[FeatureFlagsEnum.firesides_broadcasting]) {
			switch (session.session_type) {
				case SessionTypesEnum.fireside: {
					if (session.timestamp && session.end_timestamp) {
						const now = new Date().getTime();

						setIsLive(session.timestamp <= now && session.end_timestamp >= now);
						abortController.current.abort();

						if (checkInterval.current) {
							clearInterval(checkInterval.current);
						}
					}
				}
			}
		}
		else {
			setIsLive(false);
			abortController.current.abort();

			if (checkInterval.current) {
				clearInterval(checkInterval.current);
			}
		}

		return () => {
			//cleanup listener
			if (checkInterval.current) {
				clearInterval(checkInterval.current);
				abortController.current?.abort();
			}
		};
	}, [playbackUrl, session, featureFlags]);

	useEffect(() => {
		return () => {
			if (checkInterval.current) {
				clearInterval(checkInterval.current);
				abortController.current?.abort();
			}
		};
	}, []);

	return isLive;
}